const API_ROOT = {
  development: 'http://api-test.aimoox.com',
  test: 'http://api-test.aimoox.com',
  production: 'http://api.aimoox.com',
}

const API_ROOT_COMMUNITYGOVERN = {
  development: 'http://pixelmuse-op-gateway.srv.test.aimoox.com',
  test: 'http://pixelmuse-op-gateway.srv.test.aimoox.com',
  production: 'http://pixelmuse-op-gateway.srv.aimoox.com',
}

const API_ROOT_IMAGE = {
  development: 'http://pixelmuse-media-gateway.srv.test.aimoox.com',
  test: 'http://pixelmuse-media-gateway.srv.test.aimoox.com',
  production: 'http://pixelmuse-media-gateway.srv.aimoox.com',
}

const API_PREFIX = '/api'
const API_PREFIX_IMAGE = '/media'

// 扩展 - 目前未使用
const API_PREFIX_COMMUNITYGOVERN = `${API_PREFIX}/search`

const proxyMatch = new RegExp(`^${API_PREFIX}`)

const proxyMatchImage = new RegExp(`^${API_PREFIX_IMAGE}`)

const proxyMatchCommunitygovern = new RegExp(`^${API_PREFIX_COMMUNITYGOVERN}`)

const roots2Proxies = (env) => [
  {
    match: proxyMatchCommunitygovern,
    map: (path) => path.replace(API_PREFIX_COMMUNITYGOVERN, '/search'),
    host: API_ROOT_COMMUNITYGOVERN[env],
  },
  {
    match: proxyMatch,
    map: (path) => path.replace(API_PREFIX, ''),
    host: API_ROOT[env],
  },
  {
    match: proxyMatchImage,
    map: (path) => path.replace(API_PREFIX_IMAGE, ''),
    host: API_ROOT_IMAGE[env],
  },
]
module.exports = {
  project: 'pixelMuse-web',
  devPort: 7200,
  devStaticPort: 7201,
  scriptsConfig: {
    disableAutoImportAntdMobileCss: false,
  },
  production: {
    ENV: 'production',
    proxies: roots2Proxies('production'),
  },
  test: {
    ENV: 'test',
    proxies: roots2Proxies('test'),
  },
  development: {
    ENV: 'development',
    proxies: roots2Proxies('development'),
  },
}
